import {defineMessages} from 'react-intl';

export const scoreBarMessages = defineMessages({
    noResult: {
        id: 'app.componentLibrary.elements.scoreBar.noResult'
    }
});
